// extracted by mini-css-extract-plugin
module.exports = {"root":"OTPInput_root__2gMc3","otpInput":"OTPInput_otpInput__3V5MZ","otpInputError":"OTPInput_otpInputError__1jNLc","otpError":"OTPInput_otpError__1LdLP"};